"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Observation_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.observe = exports.Observation = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const schema_1 = require("../ontologies/schema");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const Thing_1 = require("./Thing");
const PropertyValue_1 = require("./PropertyValue");
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const rdf_1 = require("lincd/lib/ontologies/rdf");
const Shape_1 = require("lincd/lib/shapes/Shape");
const SHACL_1 = require("lincd/lib/shapes/SHACL");
const CoreSet_1 = require("lincd/lib/collections/CoreSet");
let Observation = Observation_1 = class Observation extends Thing_1.Thing {
    get observationDate() {
        return (this.hasProperty(schema_1.schema.observationDate) &&
            XSDDate_1.XSDDate.toNativeDate(this.getOne(schema_1.schema.observationDate)));
    }
    set observationDate(val) {
        this.overwrite(schema_1.schema.observationDate, XSDDate_1.XSDDate.fromNativeDate(val).node);
    }
    get variableMeasured() {
        return this.getOneAs(schema_1.schema.variableMeasured, PropertyValue_1.PropertyValue);
    }
    set variableMeasured(val) {
        this.overwrite(schema_1.schema.variableMeasured, val.namedNode);
    }
    get observationAbout() {
        return this.getOneAs(schema_1.schema.observationAbout, null, true);
    }
    set observationAbout(val) {
        this.overwrite(schema_1.schema.observationAbout, val.namedNode);
    }
    /**
     * Get all observations by property and date range
     * StartDate is exclusive. Meaning requesting observations from 2021-01-01 will return observations from 2021-01-01 00:00:01, but not 2021-01-01 00:00:00 (which is often used to capture totals for the day before)
     * EndDate is inclusive. Meaning requesting observations from 2021-01-01 to 2021-01-02 will return observations from 2021-01-01 00:00:01 to 2021-01-02 00:00:00
     * @param thing
     * @param propertyID
     * @param startDateExcl
     * @param endDateIncl
     * @returns
     */
    static getObservationsOf(thing, property, startDateExcl, endDateIncl, description, cacheTime) {
        return Observation_1.getSetOf(this._getObservationsOf(thing, property, startDateExcl, endDateIncl, description, cacheTime));
    }
    static _getObservationsOf(thing, property, startDateExcl, endDateIncl, description, cacheTime) {
        //For speed, this whole method uses nodes, not shapes
        //for speed efficiency, first filter by most commonly similar parameter between requests, which is the property
        // let observations:NamedNode[] = this.cached(
        //   () => {
        //     if(property) {
        //       let propValues = (schema.propertyID.getAsPredicateQuads() || []).filter(q => q.object.equals(property)).map(q => q.subject);
        //       return propValues.map(p => p.getOneInverse(schema.variableMeasured));
        //     } else {
        //       //get local instances by type, but get the nodes
        //       return [...this.targetClass.getAllInverse(rdf.type)];
        //     }
        //   },
        //   [property],
        //   cacheTime,
        // );
        let observations = this.cached(() => {
            if (thing) {
                return thing.getAllInverse(schema_1.schema.observationAbout).filter((o) => {
                    return o.has(rdf_1.rdf.type, Observation_1.targetClass);
                });
            }
            else {
                //get local instances by type, but get the nodes
                return this.targetClass.getAllInverse(rdf_1.rdf.type);
            }
        }, [thing], cacheTime);
        //filter by property
        if (property) {
            observations = this.cached(() => {
                return observations.filter((o) => {
                    var _a, _b;
                    return (_b = (_a = o
                        .getOne(schema_1.schema.variableMeasured)) === null || _a === void 0 ? void 0 : _a.getOne(schema_1.schema.propertyID)) === null || _b === void 0 ? void 0 : _b.equals(property);
                });
            }, [thing, property], cacheTime);
        }
        //next, description
        if (description) {
            observations = this.cached(() => {
                return observations.filter((o) => {
                    return o.getValue(schema_1.schema.description) === description;
                });
            }, [thing, property, description], cacheTime);
        }
        // if(thing) {
        //   observations = this.cached(
        //     () => {
        //       let thingNode = thing.namedNode;
        //       return observations.filter((o) => {
        //         return o.has(schema.observationAbout,thingNode)
        //       })
        //     },
        //     [property,description,thing],
        //     cacheTime
        //   );
        // }
        // filter by startDate
        if (startDateExcl) {
            observations = observations.filter((o) => {
                return (XSDDate_1.XSDDate.toNativeDate(o.getOne(schema_1.schema.observationDate)) >
                    startDateExcl);
            });
        }
        // filter by endDate
        if (endDateIncl) {
            observations = observations.filter((o) => {
                return (XSDDate_1.XSDDate.toNativeDate(o.getOne(schema_1.schema.observationDate)) <=
                    endDateIncl);
            });
        }
        return observations;
    }
    static cached(fn, args, cacheTime) {
        if (cacheTime) {
            const now = Date.now();
            args = args.map((a) => {
                if (a instanceof Shape_1.Shape) {
                    return a.uri;
                }
                else if (a instanceof models_1.NamedNode) {
                    return a.uri;
                }
            });
            let key = JSON.stringify(args);
            let cache = this.cache.get(key);
            if (cache && cache.timeout < now) {
                this.cache.delete(key);
                cache = null;
            }
            if (!cache) {
                let value = fn();
                this.cache.set(key, {
                    timeout: now + cacheTime,
                    value,
                });
            }
            return this.cache.get(key).value;
        }
        else {
            return fn();
        }
    }
    static hasObservationsOf(thing, property) {
        return (thing
            .getAllInverse(schema_1.schema.observationAbout)
            .filter((o) => {
            var _a, _b;
            return o.has(rdf_1.rdf.type, Observation_1.targetClass) &&
                ((_b = (_a = o
                    .getOne(schema_1.schema.variableMeasured)) === null || _a === void 0 ? void 0 : _a.getOne(schema_1.schema.propertyID)) === null || _b === void 0 ? void 0 : _b.equals(property));
        }).size > 0);
    }
    /**
     * Get the last observed value of a given thing & property
     * @param thing
     * @param property
     */
    static getLastObservedValue(thing, property, from, till, description, cacheTime) {
        var _a;
        const lastObservation = this.getLastObservationOf(thing, property, from, till, description, cacheTime);
        if (lastObservation) {
            return (_a = lastObservation.variableMeasured) === null || _a === void 0 ? void 0 : _a.value;
        }
    }
    /**
     * Find the observation with the latest observationDate of a given thing & property
     * @param thing
     * @param property
     * @param to inclusive date to filter observations. the observation must be on or before this date
     */
    static getLastObservationOf(thing, property, from, to, description, cacheTime) {
        const thingObservations = this._getObservationsOf(thing, property, from, to, description, cacheTime);
        //sort by observationDate
        let lastObservation = [...thingObservations]
            .sort((a, b) => {
            return a.getValue(schema_1.schema.observationDate) >
                b.getValue(schema_1.schema.observationDate)
                ? 1
                : -1;
        })
            .pop();
        return lastObservation ? new Observation_1(lastObservation) : null;
    }
    /**
     * Find the last observation of each shape in a set of shapes
     * and return a map of the shape's node to observation
     * @param things
     * @param propertyID
     */
    static getLastObservationsOf(things, propertyID, beforeDate) {
        const map = new Map();
        things.forEach((thing) => {
            const lastObservation = this.getLastObservationOf(thing, propertyID, null, beforeDate);
            if (lastObservation) {
                map.set(thing.namedNode, lastObservation);
            }
            return lastObservation;
        });
        return map;
    }
    /**
     * Get the value of a given property of a shape at a given date
     * Will return the regular accessor (get/set) value if this property is not observed
     * Will return the sum or average of the observations if this property is observed
     * @param shape
     * @param property
     * @param date
     */
    static getValueWithHistory(shape, property, startDate, endDate) {
        //if its observed, find historic value for this given timerange
        if (startDate && endDate) {
            const obsConf = this.isObserved(property);
            if (obsConf) {
                const observations = this.getObservationsOf(shape, property, startDate, endDate);
                // if (observations.size > 0) {
                if (obsConf.config.range === 'sum') {
                    return observations.reduce((acc, val) => {
                        return acc + parseInt(val.variableMeasured.value);
                    }, 0);
                }
                else if (obsConf.config.range === 'average') {
                    return (observations.reduce((acc, val) => {
                        return acc + parseInt(val.variableMeasured.value);
                    }, 0) / observations.size);
                }
                // }
            }
        }
        //return regular value through accessor
        let propShape = new SHACL_1.PropertyShape(property);
        return shape[propShape.label];
    }
    static createFor(shape, property, value, time, description, autoSave = true) {
        // Create and save the PropertyValue instance
        const measurement = new PropertyValue_1.PropertyValue();
        measurement.propertyID = property;
        measurement.value = value.toString();
        if (autoSave)
            measurement.save();
        // console.log('PropertyValue saved successfully');
        // Create and save the Observation instance
        const observation = new Observation_1();
        observation.observationAbout = shape;
        observation.variableMeasured = measurement;
        observation.observationDate = time;
        if (description) {
            observation.description = description;
        }
        if (autoSave)
            observation.save();
        return observation;
    }
    remove() {
        var _a;
        (_a = this.variableMeasured) === null || _a === void 0 ? void 0 : _a.remove();
        super.remove();
    }
    static isObserved(propertyShape) {
        return observed.find((c) => {
            return c.propertyShape.equals(propertyShape);
        });
    }
};
Observation.targetClass = schema_1.schema.Observation;
Observation.cache = new Map();
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.observationDate,
        dataType: XSDDate_1.XSDDate.targetClass,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], Observation.prototype, "observationDate", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        shape: PropertyValue_1.PropertyValue,
        path: schema_1.schema.variableMeasured,
    }),
    __metadata("design:type", PropertyValue_1.PropertyValue),
    __metadata("design:paramtypes", [PropertyValue_1.PropertyValue])
], Observation.prototype, "variableMeasured", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        shape: Thing_1.Thing,
        path: schema_1.schema.observationAbout,
    }),
    __metadata("design:type", Thing_1.Thing),
    __metadata("design:paramtypes", [Thing_1.Thing])
], Observation.prototype, "observationAbout", null);
Observation = Observation_1 = __decorate([
    package_1.linkedShape
], Observation);
exports.Observation = Observation;
const observed = new CoreSet_1.CoreSet();
function observe(config) {
    return function (target, propertyKey) {
        //if the shape has already been initiated (with linkedShape)
        //Note that the constructor may have shape defined if the class that it extends is already decorated with linkedShape
        //so we need to check hasOwnProperty
        (0, ShapeDecorators_1.onShapeSetup)(target, (shape) => {
            //get propertyShape
            let propertyShape = shape === null || shape === void 0 ? void 0 : shape.getPropertyShape(propertyKey);
            if (propertyShape) {
                observed.add({
                    propertyShape: propertyShape.namedNode,
                    target,
                    config,
                    propertyKey,
                });
            }
            else {
                console.error(`Property ${propertyKey} is not defined in the shape of ${target.constructor.name}`);
            }
        });
    };
}
exports.observe = observe;
//# sourceMappingURL=Observation.js.map